import React from 'react';
import { useNavigate } from 'react-router-dom';
import useSelector from '@redux/typedHooks';
import { useTrackCTA } from '@utils/Tracking/CtaClick/TrackCtaClick';
import { WORKSHOP_INTERNAL_PRODUCT_MAP } from '../../product/NafProductArticle.utils';
import { buildBookingUrl } from '../../product/components/VehicleSelecter/VehicleSelecter.utils';
import { nafCenterBasePath } from '../../../../routers/NafCenterRouter';
import S from '../styles';

interface BookingButtonProps {
  booking: any;
  bookingText: string;
  link: any;
  centerId?: number;
  internalProductId?: string;
}

const BookingButton = ({ booking, bookingText, link, centerId, internalProductId }: BookingButtonProps) => {
  const navigate = useNavigate();
  const trackCTA = useTrackCTA();
  const workshopBookingLink = useSelector((state) => state.application.nafcenterWorkshopBookingUrl);
  const productPageType = WORKSHOP_INTERNAL_PRODUCT_MAP[internalProductId];

  // Special handling for workshop products
  if (productPageType && centerId) {
    return (
      <S.BookingButton
        type="button"
        onClick={() => {
          trackCTA({ cta_position: 'content', text: 'Be om tilbud' });
          const bookingUrl = buildBookingUrl({
            baseUrl: workshopBookingLink,
            registration: '',
            centerId,
            nafCenterProductType: productPageType?.bookingType,
          });
          window.open(bookingUrl, '_blank');
        }}
      >
        Be om tilbud
      </S.BookingButton>
    );
  }

  // Default (existing) behavior
  return booking && booking.data.href && booking.type === 'externalLink' ? (
    <S.BookingButton href={booking.data.href} target={booking.data.blank ? '_blank' : '_self'}>
      Finn ledig tid
    </S.BookingButton>
  ) : (
    <S.BookingButton
      type="button"
      onClick={() => {
        trackCTA({ cta_position: 'content', text: bookingText || 'Be om tilbud' });
        navigate(link ? `/${nafCenterBasePath}/${link.data.slug}` : 'https://www.naf.no/kontakt-oss/', {
          state: { custom: true },
        });
      }}
    >
      {bookingText || 'Be om tilbud'}
    </S.BookingButton>
  );
};

export default BookingButton;
